import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import InvitationGate from './components/InvitationGate';
import Dashboard from './pages/Dashboard';
import Compliance from './pages/Compliance';
import Inventory from './pages/Inventory';
import IoTDevices from './pages/IoTDevices';
import AILearningControl from './pages/AILearningControl';
import ComplianceDashboard from './pages/ComplianceDashboard';
import ComplianceReporting from './pages/ComplianceReporting';
import ATFCompliance from './pages/ATFCompliance';
import CustomerEntry from './pages/CustomerEntry';
import AIBackgroundMonitoring from './pages/AIBackgroundMonitoring';
import Homepage from './pages/Homepage';
import MarketingHomepage from './pages/MarketingHomepage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Settings from './pages/Settings';
import FirearmsIngestion from './pages/FirearmsIngestion';
import AdminIssues from './pages/AdminIssues';
import Support from './pages/Support';
import AdminGuard from './components/AdminGuard';
import { useAuth, AuthProvider } from './hooks/useAuth';
import { TenantProvider } from './contexts/TenantContext';
import './App.css';

// Configure axios base URL for API calls - must point at backend (same host or OCI backend)
const apiBaseUrl = process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' && (window.location.hostname === 'app.darkmattersolutions.ai' || window.location.hostname === 'darkmattersolutions.ai' || window.location.hostname === 'www.darkmattersolutions.ai')
    ? 'https://app.darkmattersolutions.ai'
    : 'http://129.146.2.109');
axios.defaults.baseURL = apiBaseUrl;

function AppContent() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-400">Loading Dark Matter Solutions...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App min-h-screen bg-gray-900">
        <Routes>
          <Route path="/" element={<MarketingHomepage />} />
          <Route path="/marketing" element={<MarketingHomepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/support" element={<Support />} />
          <Route path="/firearms-ingestion" element={<FirearmsIngestion />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-gray-900">
      <Navbar />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Routes>
              <Route path="/" element={<MarketingHomepage />} />
              <Route path="/marketing" element={<MarketingHomepage />} />
              <Route path="/homepage" element={<Homepage />} />
              <Route path="/firearms-ingestion" element={<FirearmsIngestion />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/iot-devices" element={<IoTDevices />} />
              <Route path="/ai-learning-control" element={<AILearningControl />} />
              <Route path="/compliance-dashboard" element={<ComplianceDashboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/compliance-reporting" element={<ComplianceReporting />} />
              <Route path="/atf-compliance" element={<ATFCompliance />} />
              <Route path="/customer-entry" element={<CustomerEntry />} />
              <Route path="/ai-background-monitoring" element={<AIBackgroundMonitoring />} />
              <Route path="/support" element={<Support />} />
              <Route 
                path="/admin/issues" 
                element={
                  <AdminGuard>
                    <AdminIssues />
                  </AdminGuard>
                } 
              />
            </Routes>
          </motion.div>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <AppContent />
      </TenantProvider>
    </AuthProvider>
  );
}

export default App;
